import { render, staticRenderFns } from "./Funfact.vue?vue&type=template&id=657469de&"
import script from "./Funfact.vue?vue&type=script&lang=js&"
export * from "./Funfact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports